import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import i18n from "i18next";

import PageTitle from "@components/Common/PageTitle";
import Breadcrumb from "@components/Common/GlobalBreadcrumb";
import SpinnerWrapper from "@components/Common/SpinnerWrapper";
import CustomErrorBoundary from "@components/Common/CustomErrorBoundary";

import Cards from "./Cards";
import SalesModeRow from "./SalesModeRow";
import SalesSupportRow from "./SalesSupportRow";
import ServicesRow from "./ServicesRow";
import Top10ArticlesRow from "./Top10ArticlesRow";
import Top10FamiliesRow from "./Top10FamiliesRow";
import Top10SubFamiliesRow from "./Top10SubFamiliesRow";

export default function Products() {
    const { t } = useTranslation();

    moment.locale(i18n.language);

    return (
        <React.Fragment>
            <PageTitle title={t("Items")} />
            <div className="page-content">
                <Breadcrumb section={t("Statistics")} pageTitle={t("Items")} />
                <React.Suspense fallback={<SpinnerWrapper />}>
                    <CustomErrorBoundary>
                        <Cards />
                    </CustomErrorBoundary>
                </React.Suspense>
                <React.Suspense fallback={<SpinnerWrapper />}>
                    <Top10ArticlesRow />
                </React.Suspense>
                <React.Suspense fallback={<SpinnerWrapper />}>
                    <SalesModeRow />
                </React.Suspense>

                <React.Suspense fallback={<SpinnerWrapper />}>
                    <SalesSupportRow />
                </React.Suspense>

                <React.Suspense fallback={<SpinnerWrapper />}>
                    <ServicesRow />
                </React.Suspense>

                <React.Suspense fallback={<SpinnerWrapper />}>
                    <Top10FamiliesRow />
                </React.Suspense>

                <React.Suspense fallback={<SpinnerWrapper />}>
                    <Top10SubFamiliesRow />
                </React.Suspense>
            </div>
        </React.Fragment>
    );
}
